import React, { createContext, useContext } from 'react';
import type { PosCartSectionProps } from '../cart/posCartSectionProps';

type PosCartContextValue = Omit<PosCartSectionProps, 'inSheet' | 'linesScrollMaxHeight' | 'onOpenCheckout' | 'onSendCourseToKitchen' | 'canSendCourseToKitchen' | 'onPrintPreCuenta' | 'onSharePreCuenta' | 'canPrintPreCuenta' | 'printTicketIsPreCuenta' | 'onOpenSplitBill' | 'canSplitBill'> & {
  onOpenCheckout: () => void;
  onSendCourseToKitchen: () => void;
  canSendCourseToKitchen: boolean;
  onPrintPreCuenta: () => void;
  onSharePreCuenta: () => void;
  canPrintPreCuenta: boolean;
  printTicketIsPreCuenta: boolean;
  onOpenSplitBill: () => void;
  canSplitBill: boolean;
};

const PosCartContext = createContext<PosCartContextValue | null>(null);

export function PosCartProvider({
  value,
  children,
}: {
  value: PosCartContextValue;
  children: React.ReactNode;
}) {
  return <PosCartContext.Provider value={value}>{children}</PosCartContext.Provider>;
}

export function usePosCartContextOptional() {
  return useContext(PosCartContext);
}
